// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"NewsletterSubscribe-module--newsletter--1iCX7"};